import trackCampaignNoteChanges from '../helpers/trackCampaignNoteChanges'
//------------------------------
// process delete campaign note
//------------------------------
export default function processDeleteCampaignNote({
  campaign_note,
  character,
  changed_campaign_notes = [],
  original_campaign_notes = [],
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteCampaignNote note = ', campaign_note)
  //-----------------------------------------
  // build new array excluding deletion note
  //-----------------------------------------
  console.log('111 character.campaign_notes before deletion = ', character.campaign_notes)
  const newNotes = character.campaign_notes.filter((s) => s.id !== campaign_note.id)
  //------------------
  // assign new array
  //------------------
  character.campaign_notes = newNotes
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_campaign_notes = trackCampaignNoteChanges({
    campaign_note,
    original_campaign_notes: original_campaign_notes,
    changed_campaign_notes: changed_campaign_notes,
    delete: true, // used to remove entry from changed_campaign_notes where is new local note (not written to db yet)
  })
  console.log('updated_changed_campaign_notes after deletion:', updated_changed_campaign_notes)
  //---------
  // returns
  //---------
  return { character, updated_changed_campaign_notes }
}
